import styled from "styled-components";
import { COLORS } from "~/src/styles/config.style";

export const Content = styled.div`
  min-width: 50vw;
  min-height: 80vh;
  padding: 8px;
`;

export const Title = styled.h2`
  margin: 0 0 12px;
  font-size: 24px;
`;

export const Subtitle = styled.h3`
  margin: 0 0 12px;
  font-size: 18px;
`;

export const DetailsSurround = styled.div`
  height: 65vh;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const DetailsTable = styled.table<{
  textAlign?: string;
  verticalAlign?: string;
  height?: string;
  autoWidth?: boolean;
}>`
  width: ${(props) => (props.autoWidth ? "auto" : "100%")};
  height: ${(props) => props.height || "auto"};
  border-collapse: collapse;

  margin: 10px 0;

  th,
  td {
    text-align: ${(props) => props.textAlign || "left"};
    border: 1px solid #e6e6e6;
    padding: 10px;
    font-size: 14px;
    vertical-align: ${(props) => props.verticalAlign || "middle"};
  }

  th {
    background: #f8f8f8;
    font-weight: 700;
  }
`;

export const Footer = styled.div`
  margin-top: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ActionRow = styled.div`
  display: grid;
  grid-template-columns: 180px 1fr;
  gap: 12px;
  align-items: center;
`;

export const ActionHelpText = styled.span`
  font-size: 14px;
  color: #000;

  b {
    color: ${COLORS.MAIN_ORANGE};
    font-weight: 600;
  }
`;

export const Separator = styled.div`
  height: 3px;
  background: #e6e6e6;
  margin: 12px 0;
`;

export const MetadataDiv = styled.div`
  width: 50vw;
  height: 60vh;
  border: solid 2px ${COLORS.MAIN_ORANGE};
  padding: 5px;
  font-family: monospace;
  white-space: pre;
  overflow: auto;
`;
